var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState, useMemo } from 'react';
import { animated, useSpring } from '@react-spring/web';
import styled from 'styled-components';
export const index2Percent = (index = 0, max = 30) => {
    return (1 - Number(Math.min(Math.max(index, 0) / max, 1))).toLocaleString('en', {
        style: 'percent',
    });
};
export const index2Angle = (index = 0, max = 30) => {
    return `${(Number(Math.min(Math.max(index, 0) / max, 1)) * 100).toFixed()}deg`;
};
const maps = {
    light: 30,
    dark: 15,
};
export const useMoon = (_a) => {
    var { max = 30, defaultType = 'light' } = _a, props = __rest(_a, ["max", "defaultType"]);
    const [type, setType] = useState(defaultType);
    const computedIndex = useMemo(() => {
        return maps[props.type || type];
    }, [type, props.type]);
    const currentPosition = index2Percent(computedIndex, max);
    const handleToggle = () => {
        setType((prev) => {
            var _a, _b;
            if (prev === 'light') {
                (_a = props.onClick) === null || _a === void 0 ? void 0 : _a.call(props, 'dark');
                return 'dark';
            }
            else {
                (_b = props.onClick) === null || _b === void 0 ? void 0 : _b.call(props, 'light');
                return 'light';
            }
        });
    };
    const style = useSpring({
        background: `radial-gradient(circle at right top, transparent ${currentPosition},#fff ${currentPosition})`,
    });
    return {
        style,
        handleToggle,
    };
};
const StyledMoon = styled(animated.div) `
  border-radius: 100%;
  cursor: pointer;
`;
export const ThemeSwitcher = React.forwardRef((_a, ref) => {
    var { size = 20 } = _a, props = __rest(_a, ["size"]);
    const { style, handleToggle } = useMoon({
        type: props.type,
        disabled: props.disabled,
        defaultType: props.defaultType,
        max: props.max,
        onClick: props.onClick,
    });
    return (React.createElement(StyledMoon, { style: Object.assign(Object.assign(Object.assign({}, style), props.style), { width: `${size}px`, height: `${size}px` }), ref: ref, className: props.className, onClick: handleToggle }));
});
